// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"167":"detail","177":"home"}[chunkId] || chunkId) + "." + {"167":"7eee14ec","177":"a36fe5fc","398":"2b4292e2"}[chunkId] + ".js";
};